import React from 'react';
import { useParams } from 'react-router';
import {
  Card,
  CardHeader,
  CardSection,
  Layout,
  SmallHeader,
  useApi,
} from '@axiom/ui';

import { CandidateUtil } from '../../utils/candidate-util';
import { UserApi } from '../../api/user-api';
import { CandidateEngagementsApi } from '../../api/candidate-engagements-api';

import { EngagementsHistoryViewNavigationItem } from './EngagementsHistoryViewNavigationItem';

export type EngagementsHistoryViewNavigationProps = {
  name?: string;
};
export const EngagementsHistoryViewNavigation: React.FC<
  EngagementsHistoryViewNavigationProps
> = ({ name = 'ENGAGEMENTS_HISTORY_VIEW_NAVIGATION' }) => {
  const [{ data: user }] = useApi(UserApi.readUser());
  const { candidateId: urlCandidateId } = useParams();
  const candidateId = CandidateUtil.reconcileUserCandidateId(
    user,
    urlCandidateId
  );
  const [
    {
      data: {
        pastEngagementHistory,
        pastInterestHistory,
        pastSubmissionHistory,
        pastEngagementHistoryTotal,
        pastInterestHistoryTotal,
        pastSubmissionHistoryTotal,
      },
    },
  ] = useApi(CandidateEngagementsApi.readEngagementsCount(candidateId));
  return (
    <Card name={name}>
      <CardHeader>
        <SmallHeader>History</SmallHeader>
      </CardHeader>
      <CardSection>
        <Layout direction="vertical" verticalGutter="16px">
          {pastInterestHistoryTotal ? (
            <EngagementsHistoryViewNavigationItem
              name="PAST_OPPORTUNITY_INTEREST"
              url="./interest"
              badgeCount={pastInterestHistory}
            >
              Past Opportunity Interest
            </EngagementsHistoryViewNavigationItem>
          ) : null}
          {pastSubmissionHistoryTotal ? (
            <EngagementsHistoryViewNavigationItem
              name="PAST_SUBMISSIONS"
              url="./submissions"
              badgeCount={pastSubmissionHistory}
            >
              Past Submissions
            </EngagementsHistoryViewNavigationItem>
          ) : null}
          {pastEngagementHistoryTotal ? (
            <EngagementsHistoryViewNavigationItem
              name="PAST_ENGAGEMENTS"
              url="./engagements"
              badgeCount={pastEngagementHistory}
            >
              Past Engagements
            </EngagementsHistoryViewNavigationItem>
          ) : null}
        </Layout>
      </CardSection>
    </Card>
  );
};
